<template>
	<el-dialog v-dialogDrag class="setting" title="设置" :visible.sync="visible" width="420px" :before-close="onClose">
		<el-form :model="userInfo" label-width="80px" :rules="rules" ref="settingForm" size="small">
			<el-form-item label="头像" style="margin-bottom: 0 !important;">
				<file-upload class="avatar-uploader" :action="imageAction" :showLoading="true" :maxSize="maxSize"
					:isPermanent="true" @success="onUploadSuccess"
					:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
					<img v-if="userInfo.headImage" :src="userInfo.headImage" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</file-upload>
			</el-form-item>
			<el-form-item label="用户名">
				<el-input disabled v-model="userInfo.userName" autocomplete="off" size="small"></el-input>
			</el-form-item>
			<el-form-item prop="nickName" label="昵称">
				<el-input v-model="userInfo.nickName" autocomplete="off" size="small" maxlength="20"></el-input>
			</el-form-item>
			<el-form-item label="性别">
				<el-radio-group v-model="userInfo.sex">
					<el-radio :label="0">男</el-radio>
					<el-radio :label="1">女</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="个性签名">
				<el-input type="textarea" v-model="userInfo.signature" :rows="3" maxlength="64"></el-input>
			</el-form-item>
			<el-divider content-position="left">修改密码</el-divider>
			<el-form-item label="旧密码">
				<el-input type="password" v-model="pwdForm.oldPassword" show-password autocomplete="off"
					maxlength="20" placeholder="留空表示不修改密码"></el-input>
			</el-form-item>
			<el-form-item label="新密码">
				<el-input type="password" v-model="pwdForm.newPassword" show-password autocomplete="off"
					maxlength="20" placeholder="5-20位"></el-input>
			</el-form-item>
			<el-form-item label="确认密码">
				<el-input type="password" v-model="pwdForm.confirmPassword" show-password autocomplete="off"
					maxlength="20" placeholder="请再次输入新密码"></el-input>
			</el-form-item>
			<template v-if="userInfo.isAdmin === true">
				<el-form-item label="登录头像" style="margin-bottom: 0 !important;">
					<file-upload class="avatar-uploader tenant-logo-uploader" :action="imageAction" :showLoading="true"
						:maxSize="maxSize" :isPermanent="true" @success="onTenantLogoUploadSuccess"
						:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
						<img v-if="userInfo.tenantLogo" :src="userInfo.tenantLogo" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</file-upload>
				</el-form-item>
				<el-form-item label="登录说明">
					<el-input v-model="userInfo.tenantName" autocomplete="off" size="small" maxlength="64"
						placeholder="登录页展示的租户名称"></el-input>
				</el-form-item>
				<el-form-item label="公告">
					
										<el-input type="textarea" v-model="userInfo.notice" placeholder="请输入公告信息" :rows="3" maxlength="64"></el-input>

				</el-form-item>
			</template>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button @click="onClose()">取 消</el-button>
			<el-button type="primary" @click="onSubmit()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";

export default {
	name: "setting",
	components: {
		FileUpload
	},
	data() {
		return {
			userInfo: {},
			pwdForm: {
				oldPassword: "",
				newPassword: "",
				confirmPassword: ""
			},
			maxSize: 5 * 1024 * 1024,
			action: "/image/upload",
			rules: {
				nickName: [{
					required: true,
					message: '请输入昵称',
					trigger: 'blur'
				}]
			}
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		onSubmit() {
			this.$refs['settingForm'].validate((valid) => {
				if (!valid) {
					return false;
				}
				const oldPwd = this.pwdForm.oldPassword ? String(this.pwdForm.oldPassword).trim() : "";
				const newPwd = this.pwdForm.newPassword ? String(this.pwdForm.newPassword).trim() : "";
				const confirmPwd = this.pwdForm.confirmPassword ? String(this.pwdForm.confirmPassword).trim() : "";
				const needModifyPwd = !!(oldPwd || newPwd || confirmPwd);
				if (needModifyPwd) {
					if (!oldPwd || !newPwd || !confirmPwd) {
						this.$message.warning("修改密码时请完整填写旧密码、新密码和确认密码");
						return;
					}
					if (newPwd.length < 5 || newPwd.length > 20) {
						this.$message.warning("新密码长度需为5-20位");
						return;
					}
					if (newPwd !== confirmPwd) {
						this.$message.warning("两次输入的新密码不一致");
						return;
					}
				}
				const submitProfile = () => {
					this.$http({
						url: "/user/update",
						method: "put",
						data: this.userInfo
					}).then(() => {
						this.userStore.setUserInfo(this.userInfo);
						this.$emit("close");
						this.$message.success("修改成功");
					});
				};
				if (needModifyPwd) {
					this.$http({
						url: "/modifyPwd",
						method: "put",
						data: {
							oldPassword: oldPwd,
							newPassword: newPwd
						}
					}).then(() => {
						submitProfile();
					});
				} else {
					submitProfile();
				}
			});
		},
		onUploadSuccess(data, file) {
			this.userInfo.headImage = data.originUrl;
			this.userInfo.headImageThumb = data.thumbUrl;
		},
		onTenantLogoUploadSuccess(data) {
			this.userInfo.tenantLogo = data.originUrl;
		}
	},
	props: {
		visible: {
			type: Boolean
		}
	},
	computed: {
		imageAction() {
			return `/image/upload?thumbSize=20`;
		}
	},
	watch: {
		visible: function () {
			// 深拷贝
			let mine = this.userStore.userInfo;
			this.userInfo = JSON.parse(JSON.stringify(mine));
			this.pwdForm = {
				oldPassword: "",
				newPassword: "",
				confirmPassword: ""
			};
		}
	}
}
</script>

<style lang="scss" scoped>
.setting {
	.el-form {
		padding: 10px 0 0 10px;
	}

	.avatar-uploader {
		--width: 112px;

		.el-upload {
			border: 1px dashed #d9d9d9 !important;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.el-upload:hover {
			border-color: #409EFF;
		}

		.avatar-uploader-icon {
			font-size: 24px;
			color: #8c939d;
			width: var(--width);
			height: var(--width);
			line-height: var(--width);
			text-align: center;
		}

		.avatar {
			width: var(--width);
			height: var(--width);
			display: block;
		}
	}

	.tenant-logo-uploader {
		--width: 112px;
	}
}
</style>